import { Component, computed, inject, input, viewChild } from '@angular/core';
import { ILpActivity } from '@gametailors/leerplus';
import { LpRidWisselklankenActivity } from '../../../../typings/schema';
import { TOption } from '../../../components/rid-option/rid-option';
import { RidKlankSwitch, TKlankSwitchAnswer, TKlankSwitchAssignment } from '../../../mechanics/rid-klank-switch/rid-klank-switch';
import { AnnotationUtils } from '../../../utils/annotation.utils';
import { RidAssignmentBackground } from '../../components/rid-assignment-background/rid-assignment-background';
import { LEERPLUS } from '../../rid-game.utils';
import { RidAnswerService } from '../../services/rid-answer.service';
import { klankSwitchAnswer } from './rid-wisselklanken-activity.utils';

@Component({
  selector: 'rid-wisselklanken-activity',
  imports: [RidKlankSwitch, RidAssignmentBackground],
  templateUrl: './rid-wisselklanken-activity.html',
  providers: [RidAnswerService],
})
export class RidWisselklankenActivity implements ILpActivity<LpRidWisselklankenActivity> {
  private readonly $lpApiService = inject(LEERPLUS.apiToken);
  private readonly $ridAnswerService = inject(RidAnswerService);

  activity = input.required<LpRidWisselklankenActivity>();

  private readonly klankSwitch = viewChild.required(RidKlankSwitch);
  protected readonly autoPresent = !this.$lpApiService.isInWizard;

  assignments = computed<TKlankSwitchAssignment[]>(() => {
    const { words, unit } = this.activity().content;
    return words.map((p) => {
      const prompt: TOption = { type: 'CONTENT', layout: 'HORIZONTAL', audio: p.audio!.url, image: p.image!.url };
      // assignments generated before `unit` existed switch klanken
      return { prompt, word: AnnotationUtils.parse(p.annotatie), unit: unit ?? 'KLANK', shuffle: 1 };
    });
  });

  private readonly correctListeners = new Set<() => void>();

  constructor() {
    this.$lpApiService.wizard.attach('wisselklanken');
    this.$lpApiService.wizard.registerCommand('play-audio', () => this.klankSwitch().present());
    this.$lpApiService.wizard.registerCondition('word-correct', () => this.klankSwitch().isWordCorrect(), {
      allow: ['klanken'],
    });
    this.$lpApiService.wizard.registerInteraction('correct', () => new Promise<void>((resolve) => this.correctListeners.add(resolve)), {
      allow: ['klanken', 'done'],
    });
  }

  onAnswered(answer: TKlankSwitchAnswer) {
    this.$ridAnswerService.report([klankSwitchAnswer(this.activity().content.words, answer)], this.activity().uid);
  }

  onCorrect() {
    const listeners = [...this.correctListeners];
    this.correctListeners.clear();
    listeners.forEach((resolve) => resolve());
  }

  finish() {
    this.$lpApiService.finishCurrentActivity();
  }
}
